var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('UserDashboardsTemplate', [_c('UserOwnedDashboardsOrganism', {
    attrs: {
      "userId": _vm.userId
    }
  }), _c('DashboardsSharedWithUserOrganism', {
    attrs: {
      "userId": _vm.userId
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }